import { Box, Button } from '@material-ui/core';

import ModalView from '../ModalView';
import { useState } from 'react';
import { SaveDesignButton } from './SaveDesignButton';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Backdrop, Popover } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useMediaQuery } from 'react-responsive';
import AddToCart from './AddToCart';
import layout from '../../styles/layout.module.css';

export const CartActions = () => {
    const [isModalVisible, setModalVisible] = useState(false);
    const [designURL, setDesignURL] = useState('');

    const [anchorEl, setAnchorEl] = useState(null);
    const [openAddToCartBackdrop, setOpenAddToCartBackdrop] = useState(false);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1024px)' });
    const handlePopUpClose = () => {
        setAnchorEl(null);
    };
    const closeBackdropNav = () => {
        setOpenAddToCartBackdrop(false);
    };

    const modalText = (
        <p
            style={{
                width: '90%',
                marginLeft: 'auto',
                marginRight: 'auto',
                textAlign: 'center',
                fontSize: '1.3rem'
            }}>
            Copy the link below to share your design with a dealer or to add to a group order
        </p>
    );
    const modalAction = (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', gap: '10px' }}>
                <p
                    onClick={async (e) => {
                        try {
                            setAnchorEl(e.currentTarget);
                            await navigator.clipboard.writeText(designURL);
                        } catch (e) {
                            console.log(e);
                        }
                    }}
                    style={{
                        textAlign: 'center',
                        width: '90%',
                        margin: 'auto',
                        color: '#A00000',
                        wordWrap: 'break-word',
                        paddingTop: '30px'
                    }}>
                    {designURL}
                </p>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '10px',
                    height: 'auto'
                }}>
                {isTabletOrMobile && (
                    <Button
                        onClick={async () => {
                            if (navigator.share) {
                                navigator
                                    .share({
                                        title: 'My design',
                                        text: 'Check out my custom design',
                                        url: designURL
                                    })
                                    .then(() => console.log('Successful share'))
                                    .catch((error) => console.log('Error sharing', error));
                            }
                        }}>
                        Share
                    </Button>
                )}
                <div>
                    <Button
                        aria-owns={id}
                        onClick={async (e) => {
                            try {
                                setAnchorEl(e.currentTarget);
                                await navigator.clipboard.writeText(designURL);
                            } catch (e) {
                                console.log(e);
                            }
                        }}>
                        <AssignmentIcon />
                    </Button>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                        }}
                        onClose={handlePopUpClose}>
                        <p
                            style={{
                                paddingTop: '2px',
                                paddingBottom: '2px',
                                paddingLeft: ' 10px',
                                paddingRight: ' 10px'
                            }}>
                            Copied
                        </p>
                    </Popover>
                </div>
            </div>
        </div>
    );
    const closeModal = () => {
        setModalVisible(false);
    };

    return (
        <Box
            className={layout.addToCartContainer}
            style={{ display: 'flex', justifyContent: 'center', direction: 'column' }}>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openAddToCartBackdrop}
                onClick={closeBackdropNav}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <ModalView
                open={isModalVisible}
                action={modalAction}
                handleClose={closeModal}
                url={designURL}>
                {modalText}
            </ModalView>
            <AddToCart setOpenAddToCartBackdrop={setOpenAddToCartBackdrop} />
            <SaveDesignButton setDesignURL={setDesignURL} setModalVisible={setModalVisible} />
        </Box>
    );
};
